import React from 'react';

// nodejs library to set properties for components
import PropTypes from "prop-types";

import { useTranslation } from 'react-i18next';

import Icon from "@mui/material/Icon";

import MDBox from '../components/MDBox';
import MDTypography from "../components/MDTypography";

//Creamos un componente stateles, ya que no necesitamos nigun estado y son mas rapidos
export default function OthelloTituloPanelData({ ...props }) {
    const {
        margentop,
        margenboton,
        margenleft,
        tituloliteral,
        titulo,
        icon,
        bgcoloricon,
        backcoloretiqueta,
        backcolordata,
        children,
        childrenentitulo
    } = props;

    const { t } = useTranslation();

    let backetiqueta = backcoloretiqueta != null && backcoloretiqueta != '' ? backcoloretiqueta : "#262626";
    let backdata = backcolordata != null && backcolordata != '' ? backcolordata : 'white';

    let TieneHeader = (icon != null && icon != "") || (tituloliteral != null && tituloliteral != "") || (titulo != null && titulo != "")
    let TieneChildren = children != null && children != "";

    let heightHeader = 46;

    if (TieneChildren) {
        if (icon != null && icon != "")
            heightHeader = 55;
        else if (childrenentitulo)
            heightHeader = 46;
        else
            heightHeader = 48;
    }

    return (
        <MDBox mb={margenboton != null ? margenboton : 1} mr={0.5} mt={margentop != null ? margentop : 0} ml={margenleft != null ? margenleft : 0}>
            {TieneHeader ?
                <MDBox display="flex" pt={1} px={2} bgColor={backetiqueta} borderRadius={TieneChildren ? "md" : "sm"} height={heightHeader}>
                    {icon != null && icon != "" ?
                        <MDBox
                            variant="gradient"
                            bgColor={bgcoloricon != null ? bgcoloricon : "primary"}
                            color="white"
                            coloredShadow={bgcoloricon != null ? bgcoloricon : "primary"}
                            borderRadius="xl"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            width="3.5rem"
                            height="3.5rem"
                            mt={-3}
                            mr={2}
                        >
                            <Icon fontSize="medium" color="inherit">
                                {icon}
                            </Icon>
                        </MDBox> : ""
                    }
                    <MDBox display="flex" justifyContent="space-between" width='100%'>
                        <MDBox textAlign="left" lineHeight={1.25} >
                            <MDTypography variant="h6" fontWeight="light" mt={0.2} color="white">{t != null && tituloliteral != null ? t(tituloliteral) : titulo}</MDTypography>
                        </MDBox>
                        {TieneChildren && childrenentitulo != null && childrenentitulo ? <MDBox mt={-0.2}>{children}</MDBox> : ""}
                    </MDBox>
                </MDBox> : ""
            }
            {TieneChildren && !(childrenentitulo != null && childrenentitulo) ?
                <MDBox
                    color="text"
                    bgColor={backdata}
                    shadow="lg"
                    opacity={1}
                    mt={-1}
                    fontSize={14}
                    p={1}
                    pl={3}
                >
                    {children}
                </MDBox> : ""}
        </MDBox>)

}


OthelloTituloPanelData.propTypes = {
    margenboton: PropTypes.string,
    margentop: PropTypes.string,
    margenleft: PropTypes.string,
    tituloliteral: PropTypes.string,
    titulo: PropTypes.string, //Texto informativo sobre el contenido del panel
    //BackColor de la zona de texto informativo
    backcoloretiqueta: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "dark",
        "white",
    ]),
    //BackColor de la zona de datos
    backcolordata: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "dark",
        "white",
    ]),
    icon: PropTypes.node, //icono si es que equeremos añadirle esta opcion
    bgcoloricon: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "light",
        "dark",
    ]),
    childrenentitulo: PropTypes.bool
};

